export default __webpack_public_path__ + "static/media/signin.b722aefc.png";